import { h } from "@stencil/core";
import { TrainService } from "../../service/train.service";
import { findLast, findLocale, formatPrice, getLocalizedString, i18n, matchesStation } from "../../utils";
import { trainDetailsI18n } from "./train-details-i18n";
export class TrainDetails {
    constructor() {
        this.showBestPriceFinder = true;
        this.showAutoTrains = true;
        this.isOpen = false;
        this.shouldLoad = true;
    }
    componentWillLoad() {
        this.lang = findLocale(this.el);
        i18n.add(trainDetailsI18n);
        i18n.setLang(this.lang);
        if (this.isOpen) {
            this.loadData(true).then();
        }
    }
    onOpened() {
        if (this.isOpen && this.shouldLoad) {
            this.loadData(true).then();
        }
    }
    onPropsChanged() {
        if (this.isOpen) {
            this.loadData().then();
        }
        else {
            this.shouldLoad = true;
        }
    }
    updateFromTo() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        if (this.details) {
            this.offersStationFrom = (_c = (_b = (_a = this.details.route) === null || _a === void 0 ? void 0 : _a.stops) === null || _b === void 0 ? void 0 : _b.find(stop => { var _a, _b, _c; return stop.pickup && matchesStation(stop, (_a = this.searchData) === null || _a === void 0 ? void 0 : _a.fromStation, (_b = this.searchData) === null || _b === void 0 ? void 0 : _b.fromCountry, (_c = this.searchData) === null || _c === void 0 ? void 0 : _c.carTransport); })) !== null && _c !== void 0 ? _c : (_e = (_d = this.details.route) === null || _d === void 0 ? void 0 : _d.stops) === null || _e === void 0 ? void 0 : _e[0];
            this.offersStationTo = (_g = findLast((_f = this.details.route) === null || _f === void 0 ? void 0 : _f.stops, stop => { var _a, _b, _c; return stop.dropoff && matchesStation(stop, (_a = this.searchData) === null || _a === void 0 ? void 0 : _a.toStation, (_b = this.searchData) === null || _b === void 0 ? void 0 : _b.toCountry, (_c = this.searchData) === null || _c === void 0 ? void 0 : _c.carTransport); })) !== null && _g !== void 0 ? _g : (_j = (_h = this.details.route) === null || _h === void 0 ? void 0 : _h.stops) === null || _j === void 0 ? void 0 : _j[((_l = (_k = this.details.route) === null || _k === void 0 ? void 0 : _k.stops) === null || _l === void 0 ? void 0 : _l.length) - 1];
        }
    }
    async loadData(showIndicator = false) {
        try {
            this.loading = showIndicator;
            this.details = await TrainService.instance.getConnectionDetails(this.connection);
            this.updateFromTo();
            this.error = false;
            this.shouldLoad = false;
        }
        catch (e) {
            console.error('Error loading connection details: ', e);
            this.error = true;
        }
        finally {
            this.loading = false;
        }
    }
    render() {
        var _a, _b, _c;
        if (this.loading) {
            // TODO
            return (h("p", { class: "timetable-loading" }, i18n.get('timetable.loading')));
        }
        if (this.error) {
            return (h("p", { class: "timetable-message" }, i18n.get('timetable.not-found'), ' ', i18n.get('timetable.unavailable')));
        }
        return this.details ? (h("div", { class: "train-details" }, h("div", { class: "train-operator" }, this.details.partnerTrain ? (h("a", { href: this.partnerLink }, this.details.operator)) : (this.details.operator || 'Nightjet')), this.showBestPriceFinder ? (h("div", { class: "train-offers" }, h("oebbx-train-offers", { connection: this.connection, stationFrom: (_a = this.offersStationFrom) === null || _a === void 0 ? void 0 : _a.station, stationTo: (_b = this.offersStationTo) === null || _b === void 0 ? void 0 : _b.station, departure: (_c = this.offersStationFrom) === null || _c === void 0 ? void 0 : _c.dep, date: this.searchData.date, njBookingLink: this.njBookingLink, isOpen: this.isOpen }))) : null, h("div", { class: "train-timetable" }, h("oebbx-train-timetable", { route: this.details.route, searchData: this.searchData, showAutoTrains: this.showAutoTrains }), h("p", { class: "train-seasonal" }, getLocalizedString(this.details.seasonMessage))), h("div", { class: "train-map" }, h("oebbx-train-route", { route: this.details.route })), h("div", { class: "train-facilities" }, this.details.carPrice ? (h("div", { class: "train-facilities-block" }, h("oebbx-icon", { name: "car", "aria-hidden": "true" }), !this.details.motorcyclePrice ? (h("oebbx-icon", { name: "motorcycle", "aria-hidden": "true" })) : null, !this.details.motorcyclePrice ? (h("span", { class: "screen-reader-text" }, i18n.get("details.facilities", null, `${i18n.get("details.facilities.car")}/${i18n.get("details.facilities.motorcycle")}`))) : (h("span", { class: "screen-reader-text" }, i18n.get("details.facilities", null, i18n.get("details.facilities.car")))), i18n.get("details.price.from", null, formatPrice(this.details.carPrice / 100)))) : null, this.details.motorcyclePrice ? (h("div", { class: "train-facilities-block" }, h("oebbx-icon", { name: "motorcycle", "aria-hidden": "true" }), h("span", { class: "screen-reader-text" }, i18n.get("details.facilities", null, i18n.get("details.facilities.motorcycle"))), i18n.get("details.price.from", null, formatPrice(this.details.motorcyclePrice / 100)))) : null, this.details.bicycle ? (h("div", { class: "train-facilities-block" }, h("oebbx-icon", { name: "bike", "aria-hidden": "true" }), i18n.get("details.facilities.bike"))) : null, this.details.wheelchair ? (h("div", { class: "train-facilities-block" }, h("oebbx-icon", { name: "wheelchair", "aria-hidden": "true" }), h("span", null, i18n.get("details.facilities.wheelchair")))) : null), h("div", { class: "train-fineprint" }, h("p", { innerHTML: i18n.get("details.fineprint.construction", null, `<a href="https://fahrplan.oebb.at/?language=${this.lang}" target="_blank">fahrplan.oebb.at</a>`) }), this.details.partnerTrain ? (h("p", null, i18n.get("details.fineprint.partner"))) : null))) : null;
    }
    static get is() { return "oebbx-train-details"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["train-details.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["train-details.css"]
        };
    }
    static get properties() {
        return {
            "connection": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "ConnectionData",
                    "resolved": "ConnectionData",
                    "references": {
                        "ConnectionData": {
                            "location": "import",
                            "path": "../../models/nightjet",
                            "id": "src/models/nightjet.ts::ConnectionData"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false
            },
            "searchData": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "ConnectionSearchData",
                    "resolved": "ConnectionSearchData",
                    "references": {
                        "ConnectionSearchData": {
                            "location": "import",
                            "path": "../../models/nightjet",
                            "id": "src/models/nightjet.ts::ConnectionSearchData"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false
            },
            "njBookingLink": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "nj-booking-link",
                "reflect": false
            },
            "partnerLink": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "partner-link",
                "reflect": false
            },
            "showBestPriceFinder": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "show-best-price-finder",
                "reflect": false,
                "defaultValue": "true"
            },
            "showAutoTrains": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "show-auto-trains",
                "reflect": false,
                "defaultValue": "true"
            },
            "isOpen": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "is-open",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get states() {
        return {
            "loading": {},
            "error": {},
            "details": {}
        };
    }
    static get elementRef() { return "el"; }
    static get watchers() {
        return [{
                "propName": "isOpen",
                "methodName": "onOpened"
            }, {
                "propName": "connection",
                "methodName": "onPropsChanged"
            }, {
                "propName": "searchData",
                "methodName": "updateFromTo"
            }];
    }
}
//# sourceMappingURL=train-details.js.map
